import { useQuery } from '@tanstack/react-query';

import { TinyDropDownOption } from '~components/common/TinyDropDown';
import { fetcher } from '~lib/api/fetch';
import {
  COMPANY_SOURCE,
  COMPANYS_SOURCE_KEY,
  COMPANYS_SOURCE_VALUE,
  ISalaries,
  ISalaryInfo,
  ISalaryResponse,
} from '~types/company';
import { getKeyByValue } from '~utils/common/object';
import { selectSalaryType } from '~utils/company/company';

import queryKeys from '../queryKeys';

const url = (id: string) => `/api/company/${id}/salaries`;
export interface ISalaryMappedResponse extends ISalaryResponse {
  salaryGraphData: ISalaryInfo[];
  pickedSalary: ISalaryInfo;
  sourceOptions: TinyDropDownOption[];
}
export default function useGetCompanySalaryQuery(
  id: string,
  isSalaryBlocked: boolean,
  isClosed: boolean,
  selectedOption?: COMPANYS_SOURCE_VALUE,
) {
  const query = useQuery<ISalaryMappedResponse>(
    [queryKeys.companySalary, id],
    () => fetcher(url(id)),
    {
      enabled: !isSalaryBlocked && !isClosed,
      select: (response) => transformSalary(response, selectedOption),
    },
  );

  return query;
}

const transformSalary = (data: ISalaryResponse, selectedOption?: COMPANYS_SOURCE_VALUE) => {
  const tempOptions = getAcitveSource(data.salaries);
  const tempSource = Object.values(COMPANY_SOURCE).map((option) => ({
    value: option,
    disabled: tempOptions.indexOf(option) < 0,
    selected: COMPANY_SOURCE[data.defaultSource] === option,
  }));

  const sourceOptions = tempSource[0].disabled ? tempSource.slice(1) : tempSource;

  const source: COMPANYS_SOURCE_KEY = selectedOption
    ? (getKeyByValue(COMPANY_SOURCE, selectedOption) as COMPANYS_SOURCE_KEY)
    : data.defaultSource;

  const activeSalary = getActiveSalary(data, source);
  const [salary] = selectSalaryType(activeSalary);

  return {
    pickedSalary: salary,
    salaryGraphData: activeSalary,
    sourceOptions,
    ...data,
  };
};
const getAcitveSource = (data: ISalaries) => {
  const tempOptions: COMPANYS_SOURCE_VALUE[] = [];
  const keys = Object.keys(data) as COMPANYS_SOURCE_KEY[];
  keys.forEach((source) => COMPANY_SOURCE[source] && tempOptions.push(COMPANY_SOURCE[source]));

  return tempOptions;
};

const getActiveSalary = (
  salaryInfo: ISalaryResponse,
  source: COMPANYS_SOURCE_KEY,
): ISalaryInfo[] => {
  const activeSalary = salaryInfo.avg.map((each, index) => {
    if (source) {
      const salaries = salaryInfo.salaries[source][index];

      return {
        ...each,
        ...{
          ...salaries,
          salary: salaries ? salaries.salary : 0,
          updatedAt: salaries ? salaries.updatedAt : null,
        },
      };
    } else {
      return {
        ...each,
        salary: 0,
        updatedAt: null,
        rateType: 'TOTAL',
        totalRate: 0,
        industryRate: 0,
      };
    }
  });

  // @ts-ignore
  return activeSalary;
};
